<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'change-brand-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <div class="content-container">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="d-flex information-header">
            <div class="mr-auto w-100 d-flex align-item-center">
              <change-brand class="w-20 mr-2 icon-change-brand" />
              <div>Change Brand Account</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="font-medium-5">Select Brand Account</div>
        <v-select
          :searchable="true"
          class="w-100 m-auto v-select-filter login-v-select-filter"
          v-model="form.brand"
          :class="form.brand ? 'v-select-filter-selected' : null"
          placeholder="Select Brand Account"
          :options="statusOption"
        >
          <template #search="{ attributes, events }">
            <input
              class="vs__search vs-height"
              :required="!form.brand"
              v-bind="attributes"
              v-on="events"
            /> </template
        ></v-select>
      </div>
      <b-row>
        <b-col cols="12">
          <div class="privilege-btn-wrp mt-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :btn-label="'Change'"
                :type="'submit'"
                class="ml-1"
                :disabled="!canSelect"
                @click.native="onSubmitModal"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </base-modal>
</template>

<script>
import ChangeBrand from "@/@core/components/svg/common/ChangeBrand.vue";
import {
  reactive,
  ref,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from "@vue/composition-api";

export default {
  components: { ChangeBrand },
  props: {
    brandList: { type: Array, default: [] },
    currentBrandRef: { type: String, default: null },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const form = reactive({
      brand: null,
    });

    const statusOption = ref([
      { label: "BCRM - Demo/Showcase", value: 0 },
      { label: "Brand A", value: 1 },
    ]);

    const canSelect = ref(false);

    const initOption = () => {
      return new Promise((resolve) => {
        statusOption.value = [...props.brandList];
        resolve(statusOption.value);
      });
    };

    const fetchData = () => {
      if (props.brandList.length > 0 && props.currentBrandRef)
        initOption().then((value) => {
          const filterOption = value.filter(
            (o) => o.value !== props.currentBrandRef
          );
          statusOption.value = [...filterOption];
        });
    };

    const onSubmitModal = () => {
      if (vm.$listeners.onSubmit && form.brand) {
        vm.$emit("onSubmit", form.brand);
      }
    };

    onBeforeMount(() => {
      canSelect.value = false;
      fetchData();
    });

    watch(
      () => form.brand,
      () => {
        if (props.brandList.length > 0 && props.currentBrandRef && form.brand)
          canSelect.value = true;
      }
    );

    return {
      form,
      statusOption,
      onSubmitModal,
      canSelect,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>

<style>
#change-brand-modal .modal-header {
  display: none;
}

#change-brand-modal .modal-content {
  border-radius: 1.6rem;
  height: auto;
}

#change-brand-modal .modal-body {
  padding: 2rem 1.4rem;
  height: auto;
}

#change-brand-modal .information-header {
  font-size: 2.4rem !important;
  width: 100%;
  border-bottom: 1px solid #ececec;
  padding: 5px 30px 10px;
  color: #000080;
}

#change-brand-modal .icon-change-brand {
  width: 30px;
  height: 30px;
  fill: #000080;
}

#change-brand-modal .content-body {
  padding: 0 30px;
  height: 70px;
}

#change-brand-modal .v-select.vs--single .vs__selected {
  margin: 0 2px -6px 2px !important;
}

@media (min-width: 700px) {
  #change-brand-modal .modal-lg,
  #change-brand-modal .modal-xl {
    max-width: 650px;
  }
}

@media (min-width: 1300px) {
  #change-brand-modal .modal-lg,
  #change-brand-modal .modal-xl {
    max-width: 650px;
  }
}</style
>>
